import React from 'react';
import PropTypes from 'prop-types';

import './judge.scss';

const Judge = ({ name, image, description }) => (
  <div className="judge">
    <div className="judge__img">
      <img src={image} alt={name} />
    </div>
    <div className="judge__content">
      <h1 className="judge__name">
        {name}
      </h1>
      <h2 className="judge__description">
        {description}
      </h2>
    </div>
  </div>
);

Judge.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default Judge;



// WEBPACK FOOTER //
// ./src/components/Judges/Judge/index.jsx